// extracted by mini-css-extract-plugin
export var bounce = "styles-module--bounce--d6233";
export var fadeIn = "styles-module--fadeIn--0f4ae";
export var modal = "styles-module--modal--a015c";
export var overlay = "styles-module--overlay--dc835";
export var pulse = "styles-module--pulse--78a0e";